import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AGENTS_PORTAL } from '../api/constants';

function CreateAccountCTA({ data }) {
  const title = data?.title || 'Start connecting with home shoppers<br/> on Real Estate and Trulia';
  const subtitle = data?.subtitle || '';
  const btnName = data?.btn_name || 'Create an Account';
  const btnLink = data?.btn_link || `${AGENTS_PORTAL}/auth/register`;

  return (
    <div className="connect-agent-cta create-account common-padding">
      <Container>
        <div className="connect-agent-cta-wrap flex-column align-items-center">
          <div className="text-wrap mx-auto d-flex flex-column justify-content-center align-items-center text-center">
            <h2 dangerouslySetInnerHTML={{ __html: title }} />
            <p className="w-100 w-md-50">{subtitle}</p>
          </div>
          <Link to={btnLink} target="_blank" className="custom-bttn style-3">
            {btnName}
          </Link>
        </div>
      </Container>
    </div>
  );
}

export default CreateAccountCTA;